import { getUrl } from './util'

export type GameShareKind = 'flow-map' | 'record-flows' | 'roster'

type GetGameShareUrlArgs = {
	kind: GameShareKind
	gameId: GameId
	section: Section
}

export function getGameSharePreviewUrl(args: GetGameShareUrlArgs) {
	return getUrl({
		page: `/share/${args.kind}/${encodeURIComponent(args.gameId)}`,
		section: args.section,
	})
}

export function getSeasonSharePreviewUrl(section: Section) {
	return getUrl({
		page: '/share/games',
		section,
	})
}

export function getClubInviteSharePreviewUrl(clubId: ClubId, code: string) {
	return getUrl({
		page: `/share/club-invite/${encodeURIComponent(clubId)}/${encodeURIComponent(code)}`,
	})
}

export function sharePreviewPathToAppPath(pathname: string, search: string) {
	const gameMatch = pathname.match(/^\/share\/(flow-map|record-flows|roster)\/([^/]+)\/?$/)
	if (gameMatch) {
		const kind = gameMatch[1] as GameShareKind
		const decodedGameId = safeDecodeURIComponent(gameMatch[2])
		if (!decodedGameId) {
			return null
		}
		const gameId = encodeURIComponent(decodedGameId)
		const destination = kind === 'roster' ? '' : `/${kind}`

		return `/games/${gameId}${destination}${search}`
	}

	if (/^\/share\/games\/?$/.test(pathname)) {
		return `/games${search}`
	}

	const clubMatch = pathname.match(/^\/share\/club-invite\/([^/]+)\/([^/]+)\/?$/)
	if (clubMatch) {
		const clubId = safeDecodeURIComponent(clubMatch[1])
		const code = safeDecodeURIComponent(clubMatch[2])
		if (!clubId || !code) {
			return null
		}
		return `/join-club/${encodeURIComponent(clubId)}/${encodeURIComponent(code)}`
	}

	return null
}

function safeDecodeURIComponent(value: string) {
	try {
		return decodeURIComponent(value)
	} catch {
		return null
	}
}
